import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=c4c97b40"
import script from "./PrivacyConsent.vue?vue&type=script&lang=ts"
export * from "./PrivacyConsent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports